import React from 'react';
import { flattenRichText } from 'utils/richTextUtils';
import Ad from 'components/Core/Ad';
import { BannerWrapper } from './styles';

const RichTextAd = ({ fields }) => {
  const { contentInformation, image, modalForm, url } = flattenRichText(fields) || {};

  return (
    <BannerWrapper>
      <Ad
        isRichText
        url={url}
        image={image}
        modalForm={modalForm}
        className="ST_promo banner-ad--link"
        data-promocontent={contentInformation || ''}
        data-promoposition="toobox_banner"
        data-position="inline"
      />
    </BannerWrapper>
  );
};

export default RichTextAd;
